module.exports = __webpack_public_path__ + "static/img/loading.81e1aa7.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading.gif
// module id = B3Bl
// module chunks = 42